import clsx from 'clsx';
import { Button as MuiButton, makeStyles, useTheme } from '@material-ui/core';

export const Button = (props: ButtonProps) => {
  const {
    className,
    width,
    minWidth,
    height,
    fullWidth,
    buttonTheme,
    rounded,
    children,
    textColor,
    padding,
    ...rest
  } = props;

  const isTextButton = props.variant === 'text';
  const buttonWidth = fullWidth ? '100%' : width;
  const curTheme = useTheme<any>();
  const getColor = (type: string | undefined) => {
    switch (type) {
      case 'action':
        return {
          color: 'white',
          backgroundColor: curTheme.palette.paper.dark,
          hoverBorderColor: curTheme.palette.button.main,
          hoverColor: curTheme.palette.button.main,
          hoverBackgroundColor: 'transparent',
          disabledColor: 'rgb(255 255 255 / 40%)',
        };
      case 'accent':
        return {
          color: textColor ?? curTheme.palette.primary.main,
          backgroundColor: 'transparent',
          borderColor: curTheme.palette.primary.main,
          hoverColor: 'white',
          hoverBackgroundColor: curTheme.palette.primary.main,
          hoverBorderColor: curTheme.palette.primary.main,
        };
      default:
        return {
          color: isTextButton
            ? textColor ?? curTheme.palette.primary.main
            : curTheme.palette.paper.dark,
          backgroundColor: isTextButton ? 'transparent' : '#E5E5E5',
          hoverColor: isTextButton
            ? curTheme.palette.primary.dark
            : curTheme.palette.button.main,
          hoverBackgroundColor: 'transparent',
          hoverBorderColor: isTextButton
            ? 'transparent'
            : curTheme.palette.button.main,
          disabledBackgroundColor: isTextButton
            ? 'transparent'
            : 'rgba(255,255,255, 0.2)',
        };
    }
  };
  const selectedTheme =
    props.color === undefined ? getColor(buttonTheme) : undefined;
  const classes = useStyles(
    buttonWidth ?? undefined,
    minWidth ?? undefined,
    height ?? undefined,
    selectedTheme?.color ?? undefined,
    selectedTheme?.backgroundColor ?? undefined,
    selectedTheme?.hoverColor ?? undefined,
    selectedTheme?.hoverBackgroundColor ?? undefined,
    selectedTheme?.borderColor ?? undefined,
    selectedTheme?.hoverBorderColor ?? undefined,
    selectedTheme?.disabledColor ?? undefined,
    selectedTheme?.disabledBackgroundColor ?? undefined,
    padding ?? undefined
  )();
  return (
    <MuiButton
      className={clsx(className, classes.button, {
        [classes.rounded]: rounded,
      })}
      {...rest}
    >
      {children}
    </MuiButton>
  );
};

const useStyles = (
  width: any,
  minWidth: any,
  height: any,
  color: string | undefined,
  backgroundColor: string | undefined,
  hoverColor: string | undefined,
  hoverBackgroundColor: string | undefined,
  borderColor: string | undefined,
  hoverBorderColor: string | undefined,
  disabledColor: string | undefined,
  disabledBackgroundColor: string | undefined,
  padding: string | number | undefined
) =>
  makeStyles((theme) => ({
    button: {
      width: width,
      minWidth: minWidth,
      height: height,
      boxShadow: 'none',
      border: '2px solid ' + (borderColor ? borderColor : 'transparent'),
      backgroundColor: backgroundColor,
      color: color,
      whiteSpace: 'nowrap',
      boxSizing: 'border-box',
      padding: padding,

      ':hover&': {
        color: hoverColor,
        border:
          '2px solid ' +
          (hoverBorderColor ? hoverBorderColor : theme.palette.primary.dark),
        backgroundColor: hoverBackgroundColor
          ? hoverBackgroundColor
          : theme.palette.primary.dark,
        boxShadow: 'none',
      },
      '&.Mui-disabled': {
        color: disabledColor,
        backgroundColor: disabledBackgroundColor,
      },
    },
    rounded: {
      borderRadius: height ? height : 25,
    },
  }));
